module.exports = __webpack_public_path__ + "img/36t.2d4b9045.jpg";